import type { CustomEndpointServerType } from '@/services/custom-endpoint/customEndpoint';
import { ModelType } from '@tarslib/types/lib/common';
import React from 'react';
import { ApiCustomFieldList } from '../api-custom-field-list/ApiCustomFieldList';
import { ApiStatus } from '../api-status/ApiStatus';
import { BottomBanner } from '../bottom-banner/BottomBanner';
import { DocsBreadcrumb } from '../docs-breadcrumb/DocsBreadcrumb';
import { EnvironmentUrl } from '../environment-url/EnvironmentUrl';
import { Footer } from '../footer/Footer';
import { LastModifiedAt } from '../last-modified-at/LastModifiedAt';
import { MarkdownViewer } from '../markdown-viewer/MarkdownViewer';
import { Paginator } from '../paginator/Paginator';
import { ResourceHeader } from '../resource-header/ResourceHeader';
import { TagList } from '../tag-list/TagList';

export type CustomEndpointContentProps = {
  value: CustomEndpointServerType;
};

export function CustomEndpointContent(props: CustomEndpointContentProps) {
  const { value } = props;

  const environmentUrlValue = React.useMemo(() => {
    return {
      type: ModelType.CUSTOM_ENDPOINT as const,
      protocol: value.protocol,
      path: value.path,
    };
  }, [value]);

  return (
    <div className="os:pt-5">
      <DocsBreadcrumb className="mb-2 hidden os:block" />
      <ResourceHeader
        className="mb-4"
        name={value.name}
        suffix={<ApiStatus className="ml-2" status={value.status} />}
      />

      <EnvironmentUrl value={environmentUrlValue} className="mb-6" />

      <TagList className="mb-2" tags={value.tags} />

      <ApiCustomFieldList className="mb-6" />

      <MarkdownViewer className="mb-8" value={value.content} inDocView enableHeaderPlugin />

      <BottomBanner className="mb-8" />

      <LastModifiedAt className="mb-14 mt-8" />

      <Paginator className="mb-10" />

      <Footer />
    </div>
  );
}
